import { Dialog } from "@constellation-academy/framework-react-components";
import { Button } from "primereact/button";
import React, { useState } from "react";
import { graphql, useMutation } from "react-relay";
import { useTranslation } from "@i18n/hooks";
import { type CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation } from "@relay/CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation.graphql";
import { type AttachmentKind } from "@relay/DefaultFileAttachmentForm_AttachmentV2Fragment.graphql";
import { DefaultFileAttachmentForm } from "./DefaultFileAttachmentForm";
import { type FileV2 } from "../../../features/files/file-selection-field";
import { useDraftStatusUpdater } from "./use-draft-status-updater";

const ADD_DEFAULT_FILE_ATTACHMENT_MUTATION = graphql`
	mutation CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation(
		$input: AddDefaultFileAttachmentInput!
	) {
		Admin {
			Tree {
				addDefaultFileAttachment(input: $input) {
					node {
						...AttachmentEditor_TreeNodeFragment
					}
				}
			}
		}
	}
`;

type AttachmentInterface = {
	file?: FileV2;
	attachmentType?: AttachmentKind;
	description?: string;
	title?: string;
};

type OwnProps = {
	contentNodeId: string;
	canUploadFiles: boolean;
	canDeleteFiles: boolean;
};

export const CreateDefaultFileAttachmentButton = ({
	contentNodeId,
	canUploadFiles,
	canDeleteFiles,
}: OwnProps) => {
	const { t } = useTranslation("common");
	const setDraft = useDraftStatusUpdater();
	const [isOpen, setOpen] = useState(false);
	const [addDefaultFileAttachment, isAddingDefaultFileAttachment] =
		useMutation<CreateDefaultFileAttachmentButton_AddDefaultFileAttachmentMutation>(
			ADD_DEFAULT_FILE_ATTACHMENT_MUTATION,
		);

	const handleAddDefaultFileAttachment = (attachment: AttachmentInterface) => {
		if (attachment.file) {
			addDefaultFileAttachment({
				variables: {
					input: {
						fileId: attachment.file.id,
						titleOpt: attachment.title,
						descriptionOpt: attachment.description,
						nodeId: contentNodeId,
					},
				},
				updater: setDraft,
			});
		}
		setOpen(false);
	};
	return (
		<>
			<Dialog
				title={t("educationalOffer.createAttachment")}
				visible={isOpen}
				onHide={() => {
					setOpen(false);
				}}
			>
				<DefaultFileAttachmentForm
					attachmentFragmentRef={null}
					onBack={(values) => {
						handleAddDefaultFileAttachment({ ...values });
					}}
					lockButton={isAddingDefaultFileAttachment}
					canUploadFiles={canUploadFiles}
					canDeleteFiles={canDeleteFiles}
				/>
			</Dialog>
			<Button
				className={"mr-2"}
				tooltip={t("educationalOffer.attachFile")}
				icon="pi pi-paperclip"
				onClick={() => {
					setOpen(true);
				}}
			/>
		</>
	);
};
